import { InjectionToken } from '@angular/core';
import { ICommonKeyValues } from '../../@types/core';

export type TCommonLocaleDictionary = {
	[language in 'ru']: ICommonKeyValues;
};

export const LOCALE_TRANSLATIONS = new InjectionToken<TCommonLocaleDictionary>('LOCALE_TRANSLATIONS');
